import React from 'react';
import { MoreVertical, X } from 'lucide-react';
import { marginPositions } from '../../utils/portfolioData';
export function PositionsTable() {
  if (marginPositions.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full py-16" data-id="element-2242">
        <div className="w-12 h-12 rounded-full bg-background-elevated flex items-center justify-center mb-3" data-id="element-2243">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-text-tertiary" data-id="element-2244">
            <path d="M3 3v18h18" data-id="element-2245" />
            <path d="M18 17V9" data-id="element-2246" />
            <path d="M13 17V5" data-id="element-2247" />
            <path d="M8 17v-3" data-id="element-2248" />
          </svg>
        </div>
        <p className="text-sm text-text-secondary" data-id="element-2249">No open positions.</p>
      </div>;
  }
  return <div className="h-full overflow-auto" data-id="element-2250">
      <table className="w-full min-w-[800px]" data-id="element-2251">
        <thead className="sticky top-0 z-10" data-id="element-2252">
          <tr className="border-b border-border-subtle" data-id="element-2253">
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2254">
              Market
            </th>
            <th className="text-left px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2255">
              Side
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2256">
              Open Qty
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2257">
              Open Price
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2258">
              Current Price
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2259">
              Est. Liq.
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2260">
              Init. Margin
            </th>
            <th className="text-right px-3 py-2 text-[10px] font-medium text-text-tertiary uppercase tracking-wider whitespace-nowrap" data-id="element-2261">
              UP&L
            </th>
            <th className="text-right px-3 py-2" data-id="element-2262"></th>
          </tr>
        </thead>
        <tbody data-id="element-2263">
          {marginPositions.map((position, idx) => <tr key={idx} className="border-b border-border-subtle hover:bg-background-elevated transition-colors group" data-id="element-2264">
              <td className="px-3 py-2" data-id="element-2265">
                <div className="flex items-center gap-2" data-id="element-2266">
                  <img src={position.logo} alt={position.symbol} className="w-5 h-5 object-contain" data-id="element-2267" />
                  <span className="text-xs text-text-primary font-medium" data-id="element-2268">
                    {position.market}
                  </span>
                  <span className="text-[10px] text-text-tertiary bg-background-elevated px-1 py-0.5 rounded" data-id="element-2269">
                    {position.leverage}x
                  </span>
                </div>
              </td>
              <td className="px-3 py-2" data-id="element-2270">
                <span className={`text-xs font-medium ${position.side === 'Long' ? 'text-success' : 'text-danger'}`} data-id="element-2271">
                  {position.side}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2272">
                <span className="font-mono text-xs text-text-primary" data-id="element-2273">
                  {position.openQuantity.toFixed(8)}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2274">
                <span className="font-mono text-xs text-text-primary" data-id="element-2275">
                  {position.openingPrice.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2276">
                <span className="font-mono text-xs text-text-primary" data-id="element-2277">
                  {position.currentPrice.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2278">
                <span className="font-mono text-xs text-text-primary" data-id="element-2279">
                  {position.estLiquidation.toLocaleString('en-US', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2280">
                <span className="font-mono text-xs text-text-primary" data-id="element-2281">
                  {position.initialMargin.toFixed(2)}
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2282">
                <span className={`font-mono text-xs font-medium ${position.unrealizedPnl >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-2283">
                  {position.unrealizedPnl >= 0 ? '+' : ''}
                  {position.unrealizedPnl.toFixed(2)}
                  <span className="text-[10px] ml-0.5" data-id="element-2284">
                    ({position.unrealizedPnlPercent >= 0 ? '+' : ''}
                    {position.unrealizedPnlPercent.toFixed(2)}%)
                  </span>
                </span>
              </td>
              <td className="px-3 py-2 text-right" data-id="element-2285">
                <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2286">
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-2287">
                    <MoreVertical size={14} data-id="element-2288" />
                  </button>
                  <button className="p-1 hover:bg-background-primary rounded transition-colors text-text-secondary hover:text-danger" data-id="element-2289">
                    <X size={14} data-id="element-2290" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}